import "./Title.css";

const Title = ({ children }) => {
  return <h1>{children}</h1>;
};

export default Title;
